export enum ConsultationMode {
  Current = 'current',
  History = 'history',
}
